import { Button, FormGroup, Grid, TextField } from "@mui/material";
import WindowPattern from "../../../../Components/Patterns/Window";

export default function AddRubricaPlea () {

    return (
        <WindowPattern path="V.I | Pleito - Orçamento - Cronograma Financeiro - Nova Rúbrica" style={{ height: '50vh', overflow: 'hidden' }}>

            <FormGroup style={{ margin: '50px', height: '80%', justifyContent: 'center', display: 'flex' }}>

                <Grid container spacing={2}>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            required
                            label="Fornecedor"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Gasto"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            required
                            label="Mês/ano de Desembolso"
                            placeholder="Selecione..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Nacional"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Importado"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            label="Valor Total"
                            placeholder="R$"
                            disabled
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Realizado"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            label="Saldo"
                            disabled
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={12}>
                        <TextField
                            fullWidth
                            required
                            label="Descrição"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', margin: '30px 0px' }}>
                        <Button variant="contained" style={{ background: 'var(--color-blue)', width: '100px' }}>Salvar</Button>
                    </div>

                </Grid>

            </FormGroup>

        </WindowPattern>
    )
}